import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
// import omit from 'lodash/omit';

const getInternalPath = (path, query) => {
  let match;
  // match = path.match(/^\/(\?.*)?$/i);
  // if (match) {
  //   return {
  //     pathname: '/home',
  //     query: {
  //       ...query,
  //       fullPath: '/'
  //     }
  //   };
  // }
  match = path.match(/^\/logout?$/i);
  if (match) {
    return {
      pathname: '/logout',
      query: {
        ...query,
        fullPath: '/logout'
      }
    };
  }
  // match = path.match(/^\/test?$/i);
  // if (match) {
  //   return {
  //     pathname: '/test',
  //     query: {
  //       ...query,
  //       fullPath: '/test',
  //     },
  //   };
  // }
  // match = path.match(/^\/to\/([\w-%()]+)\/?(\?.*)?$/i);
  // if (match) {
  //   return {
  //     pathname: '/city',
  //     query: {
  //       ...query,
  //       city: match[1],
  //       fullPath: `/to/${match[1]}`
  //     }
  //   };
  // }
  match = path.match(/^\/explore\/([\w-%()]+)\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/explore',
      query: {
        ...query,
        city: match[1],
        fullPath: `/explore/${match[1]}`
      }
    };
  }
  match = path.match(/^\/other-cities\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/search',
      query: {
        ...query,
        city: 'Other',
        type: 'local-experiences',
        fullPath: '/other-cities'
      }
    };
  }
  match = path.match(/^\/to\/([\w-% ]+)\/([\w-%]+)\/?(\?.*)?$/i);
  if (match) {
    const internalPath = {
      pathname: '/search',
      query: {
        ...query,
        city: match[1],
        type: match[2],
        fullPath: `/to/${match[1]}/${match[2]}`
      }
    };
    if (match[3]) {
      internalPath.query.focus = match[3].split('?focus=')[1]; // eslint-disable-line
      internalPath.query.fullPath = `${internalPath.query.fullPath}${match[3]}`;
    }
    return internalPath;
  }
  match = path.match(/^\/activity.*/i);
  if (match) {
    const matchedCity = path.match(/.*[&?]city=([\w\d\s_\-%]+).*/i);
    // const matchedActivity = path.match(/.*[&?]activity=([\w\d\s_\-%]+).*/i);
    const city = matchedCity && matchedCity.length >= 2 ? matchedCity[1] : '';
    // const activity = matchedActivity && matchedActivity.length >= 2 ? matchedActivity[1] : 'all';
    return {
      pathname: '/search/activity',
      query: {
        ...query,
        city
        // activity,
      }
    };
  }
  // match = path.match(/^\/trip\/([\w-% ]+)\/?(\?.*)?$/i);
  // if (match) {
  //   return {
  //     pathname: '/trip-detail',
  //     query: {
  //       ...query,
  //       slug: match[1],
  //       fullPath: `/trip/${match[1]}`
  //     }
  //   };
  // }
  // match = path.match(/^\/ticket\/([\w-% ]+)\/?(\?.*)?$/i);
  // if (match) {
  //   return {
  //     pathname: '/trip-detail',
  //     query: {
  //       ...query,
  //       slug: match[1],
  //       fullPath: `/ticket/${match[1]}`
  //     }
  //   };
  // }
  match = path.match(/^\/local-expert\/([\w-% ]+)\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/local-expert-detail',
      query: {
        ...query,
        slug: match[1],
        fullPath: `/local-expert/${match[1]}`
      }
    };
  }
  match = path.match(/^\/article\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/article/article',
      query: {
        ...query,
        slug: 'all-article',
        fullPath: '/article'
      }
    };
  }
  match = path.match(/^\/article\/([\w-% ]+)\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/article/article',
      query: {
        ...query,
        slug: match[1],
        fullPath: `/article/${match[1]}`
      }
    };
  }
  match = path.match(/^\/dusit\/?$/i);
  if (match) {
    return {
      pathname: '/article/article',
      query: {
        ...query,
        slug: 'dusit-main'
      }
    };
  }
  match = path.match(/^\/dusit\/city\/([\w-% ]+)\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/article/article',
      query: {
        ...query,
        slug: `dusit-city-${match[1]}`
      }
    };
  }
  match = path.match(/^\/ebook\/([\w-% ]+)\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/ebook',
      query: {
        ...query,
        slug: match[1],
        fullPath: `/ebook/${match[1]}`
      }
    };
  }
  match = path.match(/^\/help-center\/?$/i);
  if (match) {
    return {
      pathname: '/help-center',
      query
    };
  }
  match = path.match(/^\/help-center\/([\w-% ]+)\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/help-center/help',
      query: {
        ...query,
        slug: match[1],
        fullPath: `/help-center/${match[1]}`
      }
    };
  }
  match = path.match(/^\/hosted-by-locals\/?$/i);
  if (match) {
    return {
      pathname: '/hosted-by-locals',
      query
    };
  }
  match = path.match(/^\/affiliate\/?$/i);
  if (match) {
    return {
      pathname: '/affiliate',
      query
    };
  }
  match = path.match(/^\/influencer\/?$/i);
  if (match) {
    return {
      pathname: '/influencer',
      query
    };
  }
  return false;
};

const _Link = props => {
  const linkData = getInternalPath(props.to, props.query);
  if (linkData && props.target !== '_blank') {
    // return (
    //   <Link prefetch href={linkData} as={props.to} {...props}>
    //     <a className={props.className}>{props.children}</a>
    //   </Link>
    // );
    const { to, itemProp, target, className, ...restLinkProps } = props;
    return (
      <Link
        href={linkData}
        as={props.to}
        {...restLinkProps}
      >
        <a onClick={restLinkProps.onClick} className={props.className}>{props.children}</a>
      </Link>
    );
  }
  const { query, ...restLinkProps } = props;
  return (
    <a href={props.to} {...restLinkProps}>
      {props.children}
    </a>
  );
};

_Link.displayName = 'Link';

_Link.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  target: PropTypes.string,
  to: PropTypes.string,
  query: PropTypes.object
};

_Link.defaultProps = {
  to: '/',
  target: '_self'
};

export default _Link;
